/**
 * https://pwaexperts.io/tutoriales/desarrolla-primera-pwa-react
 *
 * TODO:
 *   . La reserva no se esta buscando con el codigo de resort!
 *
 */


import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker.js'

import App from "./App";


/**
 * Para dev lo hacemos asi ya que no tenemos habilitado el php para insertaro desde el index.php
 */
if (process.env.NODE_ENV === 'development') {
    window.resortConfig = require('./development_config.json');

    window.setDynamicData();
}


ReactDOM.render(
    <App />,
    document.getElementById('root')
)

serviceWorker.register();
